<template>
  <div id="app" class="hr-app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'hr-app',
};
</script>
<style lang="scss">
@import '@/core/style-vars.scss';
@import 'assets/css/bootstrap.min.css';
//@import 'flag-icon-css/css/flag-icon.min.css';
@import url('https://use.typekit.net/enl7ecl.css');

#app {
  height: 100%;
}

.hr-app {
  width: 100%;
  height: 100%;
  overflow: auto;
}

html {
  font-size: 14px;

  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

* {
  -webkit-overflow-scrolling: touch;
  outline: none;
  box-sizing: border-box;
  font-family: acumin-pro, Helvetica, Arial, sans-serif;
}

.col-centered {
  float: none;
  margin: 0 auto;
}

h1 {
  font-size: 24px;
  font-weight: $font_weight-bold;
}

h3 {
  font-size: 18px;
  font-weight: $font_weight-bold;
}

a {
  color: $white;
}

input:focus {
  border-color: #66afe9;
  outline: 0;
  box-shadow: none;
}

@media print {
  .hr-app {
    overflow: visible;
  }
}
</style>
